export default "__VITE_ASSET__CyK3905f__"